/**
 * The desk task list's keyboard — tasks plan D11, as a pure table the screen
 * only dispatches on, so `test/desk-keys.test.ts` can pin every row of it.
 *
 *   ↑ / ↓            a row, not a field      focus the previous / next row
 *   Space            a row                   tick / untick
 *   Enter            a row                   focus the title field
 *   Enter            a field                 save, focus returns to the row
 *   Escape           a field                 revert, focus returns to the row
 *   Escape           a row                   close the strip
 *   Delete/Backspace a row, not a field      remove, with the Undo toast
 *   Alt+↑ / Alt+↓    a row or a field        reorder (a3-29)
 *   →                a row                   open the strip
 *   Enter            the add field           add, keep focus (the screen's own)
 *   ⌘/Ctrl+Enter     a field in the strip    save the field, focus the row
 *
 * No imports, for the root suite.
 */
export type DeskKeyAction =
  | 'focusPrev' | 'focusNext' | 'tick' | 'edit' | 'save' | 'revert' | 'remove'
  | 'stepUp' | 'stepDown' | 'openStrip' | 'closeStrip' | 'add' | 'saveStrip'

export interface DeskKey {
  key: string
  altKey?: boolean
  metaKey?: boolean
  ctrlKey?: boolean
  /** The key was pressed in a text field (input, textarea, select). */
  inField?: boolean
  /** The field is the list's own Add field. */
  inAddField?: boolean
  /** The field is one of the strip's. */
  inStrip?: boolean
}

export function deskKeyAction(k: DeskKey): DeskKeyAction | null {
  const mod = !!k.metaKey || !!k.ctrlKey
  if (k.altKey && !mod && (k.key === 'ArrowUp' || k.key === 'ArrowDown')) return k.key === 'ArrowUp' ? 'stepUp' : 'stepDown'
  if (k.altKey) return null
  if (k.inAddField) return k.key === 'Enter' && !mod ? 'add' : null
  if (k.inField) {
    if (k.key === 'Enter' && mod && k.inStrip) return 'saveStrip'
    if (k.key === 'Enter' && !mod && !k.inStrip) return 'save'
    if (k.key === 'Escape') return 'revert'
    return null
  }
  if (mod) return null
  switch (k.key) {
    case 'ArrowUp': return 'focusPrev'
    case 'ArrowDown': return 'focusNext'
    case ' ': return 'tick'
    case 'Enter': return 'edit'
    case 'Escape': return 'closeStrip'
    case 'Delete': case 'Backspace': return 'remove'
    case 'ArrowRight': return 'openStrip'
    default: return null
  }
}
